module.exports = __webpack_public_path__ + "img/ione4.1dc9872c.png";